import { FormControl, IconButton, InputBase, makeStyles, MenuItem, Select, Typography } from '@material-ui/core'
import { Visibility as ViewIcon } from '@material-ui/icons';
import SearchBarWithFilters from 'components/search_with_filters';
import tableIcons, { options } from 'components/universal/table_attributes';
import MaterialTable from 'material-table';
import React, { Children, useContext, useEffect, useState } from 'react'

import moment from 'moment';
import DispatchServices from 'lib/services/api/stores/parts/dispatch';
import useDebounce from 'lib/utils/debounce';
import { getOrganisationId } from 'lib/utils/common_utils';
import { ToastMessageContext } from 'lib/contexts/message_context';
import PartsCertificate from 'views/Stores/Parts/Stocks/PartsCertificate';
import ManageDispatch from './ManageDispatch';


const useStyles = makeStyles((theme) => ({

    wrapper: {
        margin: "2%",
        paddingBottom: "40px"
    },
    subWrapper: {
        padding: "10px"
    }

}))





function Dispatches(props) {
    const { salesId } = props
    const classes = useStyles()
    const [searchText, setSearchText] = useState("");
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [totalCount, setTotalCount] = useState(10)
    const [action, setAction] = useState(null)

    const [data, setData] = useState([])
    const message = useContext(ToastMessageContext)
    const debounceVal = useDebounce(searchText)
    const [rowDetails, setRowDetails] = useState({})
    const [loading, setLoading] = useState(false)






    const getDetails = async () => {



        const params = {
            operable_type: "SalesOrder",
            operable_id: salesId,
            page: page + 1,
            limit: pageSize,
            organisation_id: getOrganisationId(),
            search: debounceVal,

        }
        setLoading(true)
        await DispatchServices.getDispatchHistory(params).then((response) => {

            if (response.success) {

                setData(response?.data)

                setTotalCount(response.total_count)
            }


        }).catch((error) => {
            message.showToastMessage({ message: error.errors ? error.errors.join(', ') : "Something went wrong. Try again!", variant: "error" })

        }).finally(() => {
            setLoading(false)
        })



    }








    useEffect(() => {
        if (salesId) { getDetails() }


    }, [page, pageSize, debounceVal, salesId])



    const tableOptions = {
        ...options,
        page: page,
        search: false,
        total: totalCount,
        pageSize: pageSize,
        toolbar: false,
    };


    const columns = [
        {
            title: "DN #",
            field: "dn_number",
            width: "4%",
            render: (rowData) => rowData?.dn_number || " ",
        },


        {
            title: "Date",
            field: "date",
            width: "4%",
            headerStyle: {
                textAlign: "left",
            },
            cellStyle: {
                textAlign: "left",
                width: "4%",
            }
        },
        {
            title: "Items",
            field: "items",
            width: "4%",
            render: (rowData) => rowData?.line_items.length > 0 ? rowData?.line_items.length : 0
        },
        {
            title: "Total QTY",
            field: "total_quantity",
            width: "4%",
        },
        {
            title: "ALOC ID",
            field: "alloc",
            width: "4%",

        },
        {
            title: "Part #",
            field: "part",
            width: "14%",
            headerStyle: {
                textAlign: "left",
            },
            cellStyle: {
                textAlign: "left",
                width: "14%",
            }
        }, {
            title: "Description",
            field: "desc",
            width: "14%",
            headerStyle: {
                textAlign: "left",
            },
            cellStyle: {
                textAlign: "left",
                width: "14%",
            }
        },

        {
            title: "Serial #",
            field: "serial",
            width: "4%",
        }, {
            title: "Batch #",
            field: "batch",
            width: "4%",
        },

        {
            title: "Certs",
            field: "certs",
            width: "4%",
        },
        {
            title: "QTY",
            field: "qt",
            width: "4%",
        },
        {
            title: "Files",
            field: "",
            render: (rowData) => <IconButton onClick={() => {
                setAction("view_files")
                setRowDetails(rowData)
            }}>



                <ViewIcon fontSize='small' />

            </IconButton>
        },
    ]
    const handleClose = () => {
        setAction(null)
    }
    const renderActionPages = (value) => {
        const page = {

            "view_files": <ManageDispatch open={true} handleClose={handleClose} rowDetails={rowDetails} />,
            "view_cert": <PartsCertificate
                open={true}
                dialogCloseHandler={handleClose}
                selectedSecondaryPart={rowDetails}
                selectedSecondaryPartId={rowDetails?.secondary_part_id}
                title="Material Certificate"
                tabName={"parts"}
                {...props}
            />

        }
        return page[value]

    }




    return (
        <div className={classes.wrapper}>

            <Typography color="primary" style={{ marginBottom: "10px", marginLeft: "10px" }}>
                Dispatches
            </Typography>

            <div className={classes.subWrapper}>
                <SearchBarWithFilters handleSearch={(value) => {
                    setPage(0)
                    setSearchText(value);
                }} />
                <MaterialTable
                    style={{ marginTop: 20 }}
                    columns={columns}
                    icons={tableIcons}
                    title=""
                    data={data || []}
                    isLoading={loading}
                    options={tableOptions}
                    onChangePage={(page) => {
                        setPage(page);
                    }}
                    onChangeRowsPerPage={(pageSize) => {
                        setPageSize(pageSize);
                    }}

                    totalCount={totalCount}
                    page={page}
                    detailPanel={(rowData) => !rowData?.line_items?.length ? (
                        <div
                            style={{
                                marginLeft: "120px",
                                wordWrap: "break-word",
                                opacity: "50%",
                                padding: "10px",
                            }}
                        >
                            <span style={{ fontSize: "14px" }}>
                                No Records Found
                            </span>
                        </div>
                    ) : (


                        <div >
                            <MaterialTable
                                style={{ boxShadow: 'none' }}
                                icons={tableIcons}
                                title={""}
                                // classes={{
                                //     table: { tableLayout: "fixed" },
                                //     row: { padding: "0" },
                                //     cell: {
                                //         padding: "8px",
                                //         wordBreak: 'break-word',
                                //     },
                                //     header: {
                                //         padding: "8px",
                                //     },
                                // }}
                                columns={[
                                    {
                                        title: "id",
                                        field: "id",
                                        width: "33%",
                                        headerStyle: {
                                            textAlign: "left",
                                            width: "33%",
                                        },
                                        cellStyle: {
                                            textAlign: "left",
                                            width: "33%",
                                        },
                                        render: (rowData) => <span style={{ width: "33%" }}>{" "} </span>,
                                    },
                                    {
                                        title: "ALOC ID",
                                        field: "alloc_id",
                                        width: "6%",
                                        headerStyle: {
                                            textAlign: "left",
                                            width: "6%",
                                        },
                                        cellStyle: {
                                            textAlign: "left",
                                            width: "6%",
                                        },
                                    },
                                    {
                                        title: "Part #",
                                        field: "part_number",
                                        width: "14%",
                                        headerStyle: {
                                            textAlign: "left",
                                            width: "14%",
                                        },
                                        cellStyle: {
                                            textAlign: "left",
                                            width: "14%",
                                        },
                                    },

                                    {
                                        title: "Description",
                                        field: "description",
                                        width: "16%",
                                        headerStyle: {
                                            width: "16%",
                                            textAlign: "left",
                                        },
                                        cellStyle: {
                                            textAlign: "left",
                                            width: "16%",
                                        },
                                    },

                                    {
                                        title: "Serial #",
                                        field: "serial_number",
                                        width: "7%",
                                        headerStyle: {
                                            width: "7%",
                                            textAlign: "left",
                                        },
                                        cellStyle: {
                                            textAlign: "left",
                                            width: "7%",
                                        },
                                        // render: (rowData) => <span >{rowData?.serial_number || " "} </span>,
                                    },

                                    {
                                        title: "Batch #",
                                        field: "batch_number",
                                        width: "7%",
                                        headerStyle: {
                                            width: "7%",
                                            textAlign: "left",
                                        },
                                        cellStyle: {
                                            textAlign: "left",
                                            width: "7%",
                                        },
                                    },

                                    {
                                        title: "Certs",
                                        field: "certs",
                                        width: "7.4%",
                                        headerStyle: {
                                            textAlign: "right",
                                            width: "7.4%",

                                        },
                                        cellStyle: {
                                            textAlign: "left",
                                            width: "7.4%",
                                        },
                                        render: (rowData) => rowData?.secondary_part_id ?
                                            <IconButton style={{
                                                position: "absolute",

                                                margin: "-13px 0px 0px 10px"
                                            }} onClick={() => {
                                                setAction("view_cert")
                                                setRowDetails(rowData)
                                            }}>
                                                <ViewIcon fontSize='small' />

                                            </IconButton> : " "

                                    }, {
                                        title: "QTY",
                                        field: "quantity",
                                        width: "4%",
                                        headerStyle: {
                                            textAlign: "left",
                                            width: "4%",

                                        },
                                        cellStyle: {
                                            textAlign: "left",
                                            width: "4%",
                                        },

                                        render: (rowData) => <span style={{
                                            // position: "absolute",

                                            // margin: "-13px 37px"
                                        }}>{rowData?.quantity ?? "-"}</span>
                                    },
                                    {
                                        title: "Files",
                                        field: "",
                                        width: "4%",
                                    },
                                ]

                                }
                                data={rowData?.line_items || []}
                                isLoading={loading}
                                options={{
                                    ...options,
                                    toolbar: false,
                                    paging: false,
                                    header: false,
                                    padding: "dense",
                                    tableLayout: "fixed",

                                }}
                            />


                        </div>)










                    }



                />
                {action && renderActionPages(action)}

            </div>
        </div>
    )
}

export default Dispatches